import {
  DisplayCategoryCreateMutationOptions,
  DisplayCategoryUpdateMutationOptions,
  DisplayCategoryDeleteMutationOptions,
  useDisplayCategoryCreateMutation as useApolloDisplayCategoryCreateMutation,
  useDisplayCategoryUpdateMutation as useApolloDisplayCategoryUpdateMutation,
  useDisplayCategoryDeleteMutation as useApolloDisplayCategoryDeleteMutation,
} from '@occc/graphql';

import { useMutation } from '../utils';

export const useDisplayCategoryCreateMutation = (
  baseOptions: DisplayCategoryCreateMutationOptions,
) => useMutation(useApolloDisplayCategoryCreateMutation, baseOptions);

export const useDisplayCategoryUpdateMutation = (
  baseOptions: DisplayCategoryUpdateMutationOptions,
) => useMutation(useApolloDisplayCategoryUpdateMutation, baseOptions);

export const useDisplayCategoryDeleteMutation = (
  baseOptions: DisplayCategoryDeleteMutationOptions,
) => useMutation(useApolloDisplayCategoryDeleteMutation, baseOptions);
